import type { CSSProperties, ReactNode } from 'react'
import { Navbar } from './Navbar'
import { VIEW_AS_BAR_HEIGHT, ViewAsBar } from '@/features/view-as/ViewAsBar'
import { useViewAs } from '@/lib/viewAs'

// Variant A on V2: navy top navbar + a centered content column, replacing
// the old sidebar layout. Width matches the approved mockup's `.container`
// (max-width 1080px, 28px/32px/48px top/side/bottom padding — Tailwind's
// pt-7/px-8/pb-12 are exact matches for those, not approximations).
// --shell-chrome is the height of everything above <main> (the h-14 navbar, plus
// the view-as bar when it shows), for pages that fill the viewport below it.
export function AppShell({ children }: { children: ReactNode }) {
  const viewAs = useViewAs()
  const chrome = viewAs ? `calc(3.5rem + ${VIEW_AS_BAR_HEIGHT})` : '3.5rem'
  return (
    <div className="flex min-h-screen flex-col bg-background" style={{ '--shell-chrome': chrome } as CSSProperties}>
      <ViewAsBar />
      <Navbar />
      <main className="mx-auto w-full min-w-0 max-w-[1080px] flex-1 px-8 pt-7 pb-12">{children}</main>
    </div>
  )
}
